import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WatchdogService, Watchlist } from '@eightcap/core';
import { UnSubscribable } from '@core/un-subscrible';
import { AlertService } from '@core/services/alert.service';
import { LoadingService } from '@core/services/loading.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-watchdog-add',
    templateUrl: './watchdog-add.component.html',
    styleUrls: ['./watchdog-add.component.scss']
})
export class WatchDogAddComponent extends UnSubscribable implements OnInit {
    @Input()
    data: any;
    @Output()
    componentClose = new EventEmitter();

    form: FormGroup;
    watchLists: Watchlist[] = [];
    isLoading = false;

    constructor(
        private fb: FormBuilder,
        private watchdogService: WatchdogService,
        private alertService: AlertService,
        private loadingService: LoadingService
    ) {
        super();
    }

    ngOnInit(): void {
        this.buildForm();
        this.fetchWatchList();
    }

    fetchWatchList(): void {
        this.isLoading = true;
        this.watchdogService
            .filter('')
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((watchLists) => {
                this.watchLists = watchLists.filter((watchList) => {
                    const ipType = ['ip', 'block_ip'];
                    const fingerprintType = ['fingerprint', 'block_fingerprint'];
                    return ipType.includes(this.data.type)
                        ? ipType.includes(watchList.type)
                        : fingerprintType.includes(watchList.type);
                });
                this.isLoading = false;
            });
    }

    buildForm(): void {
        this.form = this.fb.group({
            id: ['', Validators.required]
        });
    }

    onSave(): void {
        const watchList = this.watchLists.find((value) => value.id === this.form.get('id').value);
        let ipList = {};
        if (watchList && watchList.ip_list) {
            ipList = JSON.parse(watchList.ip_list);
            if (Object.values(ipList).indexOf(this.data.value) > -1) {
                this.alertService.notifyError('This value is already existed in the list!');
            } else {
                const newValueKey = Object.keys(ipList)[Object.keys(ipList).length - 1]
                    ? +Object.keys(ipList)[Object.keys(ipList).length - 1] + 1
                    : 0;
                ipList = {
                    ...ipList,
                    ...{ [newValueKey]: this.data.value }
                };
                this.loadingService.show();
                this.watchdogService
                    .update(this.form.get('id').value, {
                        ip_list: JSON.stringify(ipList)
                    })
                    .subscribe({
                        next: () => {
                            this.loadingService.hide();
                            this.componentClose.emit(true);
                            this.alertService.notifySuccess('Value added!');
                        }
                    });
            }
        }
    }

    capitalize(title: string): string {
        return title.charAt(0).toUpperCase() + title.slice(1);
    }
}
